import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
// import RotatingDiv from "../components/RotatingDiv";
function Layout({ children }) {
  return (
    <div className="flex flex-col">
      <Navbar></Navbar>
      <div>{children}</div>
      {/* <RotatingDiv></RotatingDiv> */}
      <Footer></Footer>
    </div>
  );
}

export default Layout;
